import React from 'react'
import { AdminView, Analytics, AnalyticsFilter, Dict, NestedDict, PageType, QueryType } from 'app/types'
import { AnalyticsBarChart } from 'views/AdminPage/Analytics/AnalyticsBarChart'
import { AnalyticsLineChart } from './AnalyticsLineChart'
import * as fnc from 'helpers/fnc'
import { setQueryHelper } from 'helpers/query'
import { applyQuery, navigateAsync } from 'actions/appActions'
import { useAppDispatch, useAppSelector } from 'app/hooks'

interface UserAnalyticsTilerProps {
    app: AppData,
    data: NestedDict[],
    analytic: Analytics,
    maps: Dict,
}

export function UserAnalyticsTile(props: UserAnalyticsTileProps) {
    const { app, data, maps, analytic } = props

    const query = useAppSelector((state: RootState) => state.app.queries[QueryType.Analytics])
    const dispatch = useAppDispatch()

    if (analytic == Analytics.Users) {
        return <div className="analytics-tile">
            <AnalyticsLineChart title="User Visits" data={data} dateKey="visitDate" dataKey="uniqueVisits" color="var(--primary-mid)" />
        </div>
    }

    async function handleRow(x) {
        if (x.userId) {
            await dispatch(navigateAsync({ options: { dataLink: app.meta.link, extraLink: AdminView.PagesAnalytics, path: { baseRoute: 'admin' } } }))
        } else {
            await dispatch(navigateAsync({ options: { dataLink: app.meta.link, extraLink: AdminView.PagesAnalytics, path: { baseRoute: 'admin' } } }))
        }
    }
    
    function setFilter(filter, value) {
    }

    if (analytic == Analytics.Leads) {
        const userMap = fnc.objIdMap(maps.userId)
        const finalData = [...data.user, ...data.anon].sort((a, b) => parseInt(b.totalDuration) - parseInt(a.totalDuration))
        return <div className="analytics-tile">
            <h3>Top Leads</h3>
            <table>
                <thead>
                    <th>User</th>
                    <th>Viewing Duration</th>
                </thead>
                <tbody>
                    {finalData.map((x, i) => {
                        if(x.userId != null) {
                            const user = userMap[x.userId]
                            if (user) {
                                return <tr onClick={() => handleRow(x)}>
                                    <th>{user.name}</th>
                                    <td>{Math.floor(parseInt(x.totalDuration) / (1000 * 60.0))}m</td>
                                </tr>
                            }
                        } else if(x.clientId != null) {
                            return <tr onClick={() => handleRow(x)}>
                                <th>{`User - ${x.clientId.slice(0, 6)}`}</th>
                                <td>{Math.floor(parseInt(x.totalDuration) / (1000 * 60.0))}m</td>
                            </tr>
                        }
                    })}
                </tbody>
            </table>
        </div>
    }
}
